import ConcentrationIcon from "./ConcentrationIcon";

export default ConcentrationIcon;
export { ConcentrationIcon };
